import {handleActions} from 'redux-actions'
import { ADMIN_FETCH_SETTINGS_SUCCEEDED } from 'types'

const initialState = {}

export const reducer = handleActions({
  [ADMIN_FETCH_SETTINGS_SUCCEEDED]: (state, action) => action.payload.response
}, initialState)
